import { EntityForReportGenerator } from '../entity-for-report-generator';

export class FinalReportGeneratorModalPayload {
  entities: EntityForReportGenerator[];
}
